import Highcharts from 'highcharts';

export const figure58 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 180,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#dae3f3', '#5b9bd5'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
hover: {
enabled: true,
radius: 5
}
}
}
}
},

exporting: {
enabled: false
},

xAxis: [{
categories: [
	     "العالم",
	     "",
	     "أستراليا ونيوزيلندا*",
	     "أوروبا وأمريكا الشمالية",
	     "شمال أفريقيا وغرب آسيا",
	     "أمريكا اللاتينية ومنطقة البحر الكاريبي",
	     "شرق آسيا وجنوب شرق آسيا ",
	     "آسيا الوسطى وجنوب آسيا",
	     "أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)",
	     "أفريقيا جنوب الصحراء ",
	     "",
	     "البلدان غير الساحلية النامية",
	     "أقل البلدان نموًا",
	     "الدول الجزرية الصغيرة النامية",
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
useHTML: true,
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
max: 5,
min: 0,
tickInterval: 1,
gridLineWidth: 0,
title: {
text: 'متوسط المستوى عند التنفيذ: 1 الأدنى – 5 الأعلى',
style: {
color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
name: '2018',
tooltip: {
valuePrefix: ''
},
dataLabels: {
enabled: true,
format: '{point.label}', // Display the label
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '12px'
}
},
data: [
3,
{ y: 0 },
5,
5,
3,
3,
4,
3,
4,
4,
{ y: 0 },
{ y: 0, label: 'لا ينطبق' },
3,
3,
],
},
{
name: '2022',
tooltip: {
valuePrefix: ''
},
dataLabels: {
enabled: true,
format: '{point.label}', // Display the label
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '12px'
}
},
data: [
4,
{ y: 0 },
{ y: 0 },
5,
4,
4,
4,
3,
4,
3,
{ y: 0 },
{ y: 0, label: 'لا ينطبق' },
3,
4,
]
}]
}
